<mat-form-field class="w-100" [ngClass]="{ 'no-underline': readonly }" [floatLabel]="'always'">
  <mat-label class="mat-subtitle2" [hidden]="!fgInfo?.label">
    {{ labelOverride || fgInfo?.label }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
  </mat-label>
  <app-lookup-component
    [placeholder]="placeholder"
    [formControl]="formControl"
    [required]="getRequired()"
    [readonly]="readonly"
    [lookupType]="lookupType"
    [lookupTypes]="lookupTypes"
    [searchType]="searchType"
    [queryObject]="queryObject"
    (dataChanges)="onDataChanges($event)"
    [disableLink]="disableLink"
  ></app-lookup-component>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error>
</mat-form-field>
